import React from "react";

/**
 * The Knowledge Base landing's banner (ACOP-149): the same AvSight Knowledge Base logo image every article
 * carries, on the same navy gradient the article stylesheet gives its header, so the glossary/search page
 * reads as one of the family (Home and each article have theirs).
 *
 * The image is the white-on-transparent wordmark that NEEDS the navy behind it — which is exactly why
 * articles looked blank when their stylesheet was lost (ACOP-148). A navy band reads the same in light
 * and dark mode, so there is no second, dark-mode logo to maintain. Sized by width with `height: auto`
 * (never a fixed height), so the artwork is not clipped at any width.
 *
 * Router-free and stateless, so it is trivially unit-testable.
 */
export const KB_BANNER_SRC = "https://kb.inscaletech.com/kbs/common/kb-banner-img.png";

export default function KbBanner() {
  return (
    <header className="kb2-banner" data-testid="kb2-banner">
      <img
        className="kb2-banner-img"
        src={KB_BANNER_SRC}
        alt="AvSight Knowledge Base"
        width={1172}
        height={154}
        data-testid="kb2-banner-img"
      />
    </header>
  );
}
